import {faro, LogLevel} from '@grafana/faro-web-sdk';
import type {AnalyticsSink, Props} from '../types';

// Faro context/attributes must be string maps.
const toStrings = (props: Props): Record<string, string> =>
  Object.fromEntries(
    Object.entries(props).map(([k, v]) => [
      k,
      typeof v === 'string' ? v : JSON.stringify(v) ?? String(v),
    ]),
  );

// faro.api is a no-op until initFaro() runs (or when FARO_URL is unset).
export const faroSink: AnalyticsSink = {
  name: 'faro',
  track(name, props) {
    faro.api.pushEvent(name, toStrings(props));
  },
  log(level, message, context) {
    faro.api.pushLog([message], {
      level: level as LogLevel,
      context: toStrings(context),
    });
  },
  error(err, context) {
    faro.api.pushError(err instanceof Error ? err : new Error(String(err)), {
      context: toStrings(context),
    });
  },
  measure(name, value, attrs) {
    faro.api.pushMeasurement(
      {type: name, values: {value}},
      {context: toStrings(attrs)},
    );
  },
  // Id only: traits can carry PII and don't belong in logs.
  identify(userId) {
    faro.api.setUser({id: userId});
  },
  reset() {
    faro.api.resetUser();
  },
};
